/*
 * @FilePath     : /fe-eshotel/src/application/createComponent.js
 * @Author       : LiYang
 * @Date         : 2021-08-25 20:33:39
 * @LastEditTime : 2021-11-01 16:28:47
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import { createComponent } from '@mpxjs/core'
import creator from './common'
export default creator(createComponent, 'component')
